/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Valve_CountInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Th. head" |
* | "other" | "Th. heads" |
*
* @param {Valve_CountInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valve_count = /** @type {((inputs: Valve_CountInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valve_CountInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`Th. head`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`Th. heads`);
		return /** @type {LocalizedString} */ ("valve_count");
	}
	{
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`Tête th.`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`Têtes th.`);
		return /** @type {LocalizedString} */ ("valve_count");
	}
});